import { schema } from 'normalizr';

export default new schema.Entity(
  'trips',
  {},
  {
    idAttribute: 'tripId',
  }
);
